import styles from './MediaElement.module.scss'
import cx from 'classnames'
import React from 'react'
import Image from '../../../components/Image'
import { SettingType } from '../../../types/GlobalSetting'
import { usePluginContext } from '../../../contexts/PluginContext'

type MediaElementProps = {
    src: string
    alt: string
    classes?: string
    showBackground?: boolean
}

const MediaElement: React.FC<MediaElementProps> = ({
    src,
    alt,
    classes,
    showBackground,
}: MediaElementProps) => {
    const { getSettingValue } = usePluginContext()
    const showBg = showBackground===undefined ? getSettingValue('show_bg_in_media_element', SettingType.BOOLEAN) : showBackground
    const className = cx(showBg ? styles['zr-media-element-bg'] : undefined, classes)

    return (
        <div className={className}>
            <Image
                src={src}
                alt={alt}
                width={'100%'}
                objectFit={'contain'}
                classes={cx(styles['zr-media-element-image'])}
            />
        </div>
    )
}

export default MediaElement
